import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import {LabelSetForm, LabelSetFormValues} from "../../components/pages/admin/LabelSet/LabelSetForm";
import {useSystemMessage} from "../../hooks/useSystemMessage";
import useAppRouter from "../../hooks/useAppRouter";
import {labelSetApi} from "../../apis/admin/menu/labelSetApi";
import {ApiClientError} from "../../apis/errors";
import {logError} from "../../libs/utils/logError";

export const LabelSetCreatePage: React.FC = () => {
  const defaultValues: LabelSetFormValues = {
    name: '',
    content: '',
    labelList: [],
  };
  const { success } = useSystemMessage();
  const [ abortController, setAbortController ] = useState<AbortController | undefined>();
  const [ apiClientError, setApiClientError] = useState<ApiClientError | null>(null);
  const { goto } = useAppRouter();
  const location = useLocation();

  const clearApiClientError = async (): Promise<void> => {
    setApiClientError(null);
  };

  const onSave = async (data: LabelSetFormValues): Promise<void> => {
    setAbortController(new AbortController());
    try {
      await labelSetApi.create(
        {
          name: data.name,
          content: data.content,
          labelList: data.labelList,
        },
        {abortSignal: abortController?.signal});
      setAbortController(undefined);
      await success('ラベルセットを作成しました。');
      goto('labelSetList');

    } catch (e) {
      await logError(
        location.pathname,
        'ラベルセットの作成に失敗しました。',
        e
      );

      if (e instanceof ApiClientError) {
        setApiClientError(e);
        return;
      }

      goto('internalServerError');
    }
  };

  return (
    <>
      <LabelSetForm
        {...{
          defaultValues,
          isEdit: false,
          apiClientError,
          clearApiClientError,
          onSave,
        }}
      />
    </>
  );
};
